import Model from 'src/storage/list';
import { hasSameId } from 'src/helpers';
import doctorModel from './doctorModel';

export class ClinicProfileDoctorsModel extends Model {
  id = 'ClinicProfileDoctorsModel';
  refreshOnInit = false;
  refreshOnSubscribe = true;
  sortBy = null;
  defaultState = () => ({
    current: 'recent',
    clinic: null,
    activeTab: 'medici',
    specialist: null
  });
  _events = {
    'foxsocket:message:contact_update': 'handleContactUpdateWS'
  };
  apiConfig = {
    refresh: {
      url: 'clinic/doctor/all',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    list: {
      url: 'clinic/doctor/all',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    search: {
      url: 'clinic/doctor/all',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    }
  };

  listParams(loadMore) {
    const req = {
      clinicId: this.state.clinic?.id,
      specialist: this.state.specialist,
      skip: 0,
      joined: true,
      limit: this.listLimit
    };
    const query = this.listInput('search');

    if (query.length > 0) {
      req.query = query;
    }
    if (loadMore) {
      let skip = this.items().length;
      if (skip < this.listLimit) return null;
      req.skip = skip;
    }
    return req;
  }

  onChangeSpecialist(specialist) {
    this.setState({ specialist });
    this.refresh();
  }

  handleContactUpdateWS = ({ data }) => {
    const doctorId = data?.partnerId || data?.id;

    if (!doctorId || typeof data?.connections === 'undefined') {
      return;
    }

    const existingDoctor = [...this.items('recent'), ...this.items('search')].find((item) =>
      hasSameId(item.id, doctorId)
    );

    const nextDoctorData = {
      id: existingDoctor?.id || doctorId,
      connections: data.connections,
      ...(typeof data?.lastActivity !== 'undefined' ? { lastActivity: data.lastActivity } : {})
    };

    this.updateItem(nextDoctorData);

    if (hasSameId(doctorModel.state.doctor?.id, doctorId)) {
      doctorModel.setState({
        doctor: {
          ...doctorModel.state.doctor,
          ...nextDoctorData
        }
      });
    }
  };
}

const model = new ClinicProfileDoctorsModel();
export default model;
